
import React from 'react';

interface ProgressBarProps {
  value: number;
  label?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, label }) => {
  const normalizedValue = Math.min(Math.max(value, 0), 100);
  
  let colorClass = 'bg-green-500';
  if (normalizedValue > 75) colorClass = 'bg-yellow-500';
  if (normalizedValue > 90) colorClass = 'bg-red-500';

  return (
    <div>
        {label && <p className="text-sm text-text-secondary mb-1">{label}</p>}
        <div className="w-full bg-gray-700 rounded-full h-2.5">
            <div
                className={`h-2.5 rounded-full transition-all duration-500 ${colorClass}`}
                style={{ width: `${normalizedValue}%` }}
            ></div>
        </div>
    </div>
  );
};

export default ProgressBar;
